/**
 * themes
 *
 */
export default {
  cookieName: 'current-theme',
  DARK: 'dark',
  LIGHT: 'light'
};
